._ImageBlock_zu22i_1 {
  position: relative;
  margin: 8px 0;
  display: block;
}
._ImageBlock_zu22i_1._align-left_zu22i_6 {
  text-align: left;
}
._ImageBlock_zu22i_1._align-center_zu22i_9 {
  text-align: center;
}
._ImageBlock_zu22i_1._align-right_zu22i_12 {
  text-align: right;
}
._ImageBlock_zu22i_1._resizing_zu22i_15 ._image_zu22i_15 {
  box-shadow: 0 0 0 2px #1890ff;
}
._ImageBlock_zu22i_1._resizing_zu22i_15 ._resizeHandle_zu22i_18 {
  background: #40a9ff;
  transform: scale(1.2);
}

._imageContainer_zu22i_23 {
  position: relative;
  display: inline-block;
  max-width: 100%;
}
._imageContainer_zu22i_23:hover ._controls_zu22i_28 {
  opacity: 1;
  visibility: visible;
}
._imageContainer_zu22i_23:hover ._resizeHandle_zu22i_18 {
  opacity: 1;
  visibility: visible;
}
._imageContainer_zu22i_23:hover ._image_zu22i_15 {
  outline: 2px solid rgba(24, 144, 255, 0.3);
  outline-offset: 2px;
}

._image_zu22i_15 {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s;
}
._image_zu22i_15:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

._resizeOverlay_zu22i_52 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(24, 144, 255, 0.1);
  border: 2px dashed #1890ff;
  border-radius: 4px;
  pointer-events: none;
  z-index: 5;
}

._resizeInfo_zu22i_65 {
  position: absolute;
  top: -30px;
  right: 0;
  background: #1890ff;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
._resizeInfo_zu22i_65::after {
  content: "";
  position: absolute;
  top: 100%;
  right: 8px;
  border: 4px solid transparent;
  border-top-color: #1890ff;
}

._controls_zu22i_28 {
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 4px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  z-index: 10;
}

._controlButton_zu22i_99 {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
._controlButton_zu22i_99:hover {
  background: rgb(255, 255, 255);
  border-color: #40a9ff;
}

._altEditContainer_zu22i_110 {
  display: flex;
  gap: 4px;
  align-items: center;
}

._altInput_zu22i_116 {
  width: 150px;
}

._altSaveButton_zu22i_120 {
  min-width: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

._resizeHandle_zu22i_18 {
  position: absolute;
  width: 24px;
  height: 24px;
  background: #1890ff;
  border: 2px solid #fff;
  border-radius: 50%;
  cursor: nw-resize;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  user-select: none;
  pointer-events: auto;
}
._resizeHandle_zu22i_18._bottomRight_zu22i_146 {
  bottom: -12px;
  right: -12px;
  cursor: nw-resize;
}
._resizeHandle_zu22i_18:hover {
  background: #40a9ff;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
._resizeHandle_zu22i_18:active {
  background: #096dd9;
  transform: scale(1.05);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);
}
._resizeHandle_zu22i_18 svg {
  color: white;
  width: 12px;
  height: 12px;
  pointer-events: none;
}
._resizeHandle_zu22i_18::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  pointer-events: none;
}

._menuItem_zu22i_179 {
  display: flex;
  align-items: center;
  gap: 8px;
}

._activeAlignment_zu22i_185 {
  background-color: #e6f7ff;
  color: #1890ff;
}